import { createStyles, makeStyles } from "@material-ui/core";
const FTLTableFooterStyles = makeStyles((theme) => createStyles({
    root: {
        zIndex: 4,
        position: "absolute",
        bottom: 0,
        background: "#ffffff",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "80px",
        borderTop: "2px solid #ebedf0",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            justifyContent: "center",
            height: "auto",
        },
    },
    container: {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4),
        },
    },
    pageSizeContainer: {
        display: "flex",
        alignItems: "center",
    },
    pageSizeWrapper: {
        cursor: "pointer",
        marginLeft: "8px",
    },
    pageSizeIcon: {
        marginLeft: "16px",
        width: "20px",
        height: "20px",
    },
    paginationContainer: {
        display: "flex",
        alignItems: "center",
        "& > button": {
            width: "32px",
            margin: "4px",
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing(6),
        },
    },
    listItem: Object.assign(Object.assign({}, theme.typography.listItemText), { backgroundColor: "#fff", color: theme.palette.text.primary, cursor: "pointer", outline: "none", "&:hover": {
            backgroundColor: "#f5f5f6",
        } }),
}));
export default FTLTableFooterStyles;
//# sourceMappingURL=FTLTableFooterStyles.styles.js.map